import { createDynamicSlice } from ".";
import { getUserListThunk } from "../thunks/usersThunk";

export const usersSlice = createDynamicSlice({
  name: "users",
  thunk: getUserListThunk,
  listMode: true,
  resetActionName: "resetUsers",
});

export const usersReducer = usersSlice.reducer;
export const { resetUsers } = usersSlice.actions;
